import type React from 'react';

import { useSharingTools } from '../../hooks/useSharingTools';

import { RecommendedGroupsCardPreview } from './components/RecommendedGroupsCardPreview';

export const RecommendedGroupsCard: React.FC = () => {
	const { data, actions } = useSharingTools();

	if (!data.recommendedGroups.isLoading && data.recommendedGroups.groups.length === 0) {
		return null;
	}

	return (
		<RecommendedGroupsCardPreview
			recommendedGroups={data.recommendedGroups}
			primaryAction={actions.navigateToGroupRecommendations}
			onFacebookGroupClick={actions.openRecommendedFacebookGroupModal}
			onRedditGroupClick={actions.openRecommendedRedditGroupModal}
		/>
	);
};
